import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ModalShell from '@/components/modal-shell';
import { Button } from '@/components/ui/button';

interface DeleteExperienceModalProps {
  experienceTitle: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteExperienceModal({ experienceTitle, onClose, onConfirm }: DeleteExperienceModalProps) {
  const { t } = useTranslation();
  return (
    <ModalShell title={t('modals.deleteExperience.title')} onClose={onClose}
      icon={<Trash2 aria-hidden='true' className='h-5 w-5 shrink-0 text-ws-text' />}>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-2'>
          <p className='font-medium text-ws-text'>
            {t('modals.deleteExperience.message', { title: experienceTitle })}
          </p>
          <p className='text-sm text-ws-muted'>
            {t('modals.deleteExperience.warning')}
          </p>
        </div>

        <div className='flex items-center justify-between gap-3'>
          <Button variant='secondary' onClick={onClose}>{t('common.cancel')}</Button>
          <Button variant='primary' onClick={onConfirm}>{t('common.delete')}</Button>
        </div>
      </div>
    </ModalShell>
  );
}
